import React, { useState } from 'react';
import ScheduleTile from './ScheduleTile.jsx';
import { Row } from 'react-bootstrap'

function ScheduleList(props) {
  const [expandedSchedule, setExpandedSchedule] = useState(null)

  return (
    <Row>
      { props.schedules.map(schedule => {
        const isExpanded = expandedSchedule && expandedSchedule.id === schedule.id
        return (
          <ScheduleTile
            key={schedule.id}
            schedule={schedule}
            setExpanded={() => setExpandedSchedule(schedule)}
            clearExpanded={() => setExpandedSchedule(null)}
            expanded={isExpanded}
            onAddEntry={props.onAddEntry}
            onEditEntry={props.onEditEntry} />
        )
      })}
    </Row>
  );
}
export default ScheduleList;
